module.exports = __webpack_public_path__ + "static/media/request_headers.3d7b8a40.png";